import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import AppRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import AppChoicesProvider from "./components/app-choices/AppChoicesProvider";
import StagingIndicator from "./components/StagingIndicator";
import { IS_STAGING } from "./helpers/constants";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-datepicker/dist/react-datepicker.css";

const App = () => {
  return (
    <>
      <ToastContainer autoClose={1500} />
      <AppChoicesProvider>
        <AppRoutes />
      </AppChoicesProvider>
      {IS_STAGING && <StagingIndicator />}
    </>
  );
};

export default App;
